if (!customElements.get('dbtfy-rte')) {
  customElements.define(
    'dbtfy-rte',
    class DbtfyRte extends HTMLElement {
      constructor() {
        super();
        this.toggleButton = this.querySelector('.rte-toggle-button');
        this.shortDescription = this.querySelector('.short-description');
        this.Button = this.querySelectorAll('.button-show');
      }

      connectedCallback() {
        if (this.toggleButton) this.toggleButton.addEventListener('click', this.onToggleRte.bind(this));
      }

      onToggleRte() {
        this.shortDescription.classList.toggle('show-full');
        this.Button.forEach((button) => button.classList.toggle('hidden'));
      }
    }
  );
}
